export default __webpack_public_path__ + "static/media/sims-summary.b9504a69.png";